import { render, staticRenderFns } from "./CheckListItem.vue?vue&type=template&id=faf38242&"
import script from "./CheckListItem.vue?vue&type=script&lang=js&"
export * from "./CheckListItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports